import { render, staticRenderFns } from "./SaldoButton.vue?vue&type=template&id=4900a234&"
import script from "./SaldoButton.vue?vue&type=script&lang=ts&"
export * from "./SaldoButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports